import { Link } from 'react-router-dom';
import { Dumbbell, MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-power-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Dumbbell className="h-8 w-8 text-power-red" />
              <span className="text-2xl font-bold">PowerGym</span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Transform your body, transform your life. Join the ultimate fitness revolution with state-of-the-art equipment and expert trainers.
            </p>
            <div className="flex space-x-4">
              <button className="text-gray-400 hover:text-power-red transition-colors duration-300">
                <Facebook className="h-6 w-6" />
              </button>
              <button className="text-gray-400 hover:text-power-red transition-colors duration-300">
                <Instagram className="h-6 w-6" />
              </button>
              <button className="text-gray-400 hover:text-power-red transition-colors duration-300">
                <Twitter className="h-6 w-6" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-power-red">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-300 hover:text-power-red transition-colors duration-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-power-red transition-colors duration-300"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-power-red transition-colors duration-300"
                >
                  Services
                </button>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-power-red transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-power-red">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-power-red transition-colors duration-300">
                  Personal Training
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-power-red transition-colors duration-300">
                  Group Classes
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-power-red transition-colors duration-300">
                  Nutrition Counseling
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-power-red transition-colors duration-300">
                  Recovery & Wellness
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-power-red">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-power-red flex-shrink-0" />
                <span className="text-gray-300">123 Fitness Street, Gym City, GC 12345</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-power-red flex-shrink-0" />
                <span className="text-gray-300">(555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-power-red flex-shrink-0" />
                <span className="text-gray-300">info@powergym.com</span>
              </div>
            </div>
            <button className="bg-power-red hover:bg-red-700 text-white font-bold py-2 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg w-full">
              Join Now
            </button>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 PowerGym. All rights reserved. Built with passion for fitness.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;